export default __webpack_public_path__ + "static/media/deathlord.11f50564.png";